import React from 'react';

interface AdminStatCardProps {
  label: string;
  value: string;
  hint: string;
}

const AdminStatCard: React.FC<AdminStatCardProps> = ({ label, value, hint }) => (
  <div className="rounded-[28px] border border-white/10 bg-white/5 p-5">
    <div className="text-[11px] uppercase tracking-[0.34em] text-amber-100/45">{label}</div>
    <div className="mt-3 arab-gold-text text-4xl font-semibold">{value}</div>
    <div className="mt-2 text-sm text-white/45">{hint}</div>
  </div>
);

export default AdminStatCard;

